import { render, staticRenderFns } from "./sbol-payment-modal.vue?vue&type=template&id=15181f44&scoped=true&lang=pug&"
import script from "./sbol-payment-modal.vue?vue&type=script&lang=js&"
export * from "./sbol-payment-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15181f44",
  null
  
)

export default component.exports